import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import LandingPage from "./landing/LandingPage";
import { ThemeProvider } from "./contexts/ThemeContext";

// Lazy-load everything off the funnel's critical path (recharts lives in HomePage/Calculator).
const HomePage = lazy(() => import("./HomePage"));
const Admin = lazy(() => import("./Admin"));
const Calculator = lazy(() => import("./Calculator"));
const SocialsPage = lazy(() => import("./social/SocialsPage"));
const NotFound = lazy(() => import("./NotFound"));

function Loading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-paper">
      <div className="h-7 w-7 animate-spin rounded-full border-2 border-line border-t-jade" />
    </div>
  );
}

function SiteHome() {
  return <LandingPage />;
}

function App() {
  return (
    <ThemeProvider>
      <Router basename={window.location.pathname.startsWith('/smbf') ? '/smbf' : '/'}>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<SiteHome />} />
            <Route path="/pathway" element={<LandingPage />} />
            <Route path="/socials" element={<SocialsPage />} />
            <Route path="/calculator" element={<Calculator />} />
            <Route path="/model" element={<HomePage />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Router>
    </ThemeProvider>
  );
}

export default App;
